module.exports = __webpack_public_path__ + "static/media/cleaning_important.586963ba.svg";